// Author Shi Wen Long
// Date 2021-08-25 12:04:20

class SithMesPrdSdProject {
constructor({
        id = null,
        projectDefinition = '',
        startDate = '',
        finishDate = '',
        remark = ''}
= {}) {
    this.id = id;
    this.projectDefinition = projectDefinition;
    this.startDate = startDate;
    this.finishDate = finishDate;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesPrdSdProject();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.prd.sithMesPrdSdProject.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'projectDefinition',
        label: 'label.sith.prd.sithMesPrdSdProject.grid.projectDefinition',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'startDate',
        label: 'label.sith.prd.sithMesPrdSdProject.grid.startDate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'finishDate',
        label: 'label.sith.prd.sithMesPrdSdProject.grid.finishDate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdSdProject.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    projectDefinitionFilter : "",
    startDateRteFilter : "",
    startDateLteFilter : "",
    finishDateRteFilter : "",
    finishDateLteFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'projectDefinitionFilter',
        label: 'label.sith.prd.sithMesPrdSdProject.filter.projectDefinition',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'startDateRteFilter',
        label: 'label.sith.prd.sithMesPrdSdProject.filter.startDateRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'startDateLteFilter',
        label: 'label.sith.prd.sithMesPrdSdProject.filter.startDateLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'finishDateRteFilter',
        label: 'label.sith.prd.sithMesPrdSdProject.filter.finishDateRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'finishDateLteFilter',
        label: 'label.sith.prd.sithMesPrdSdProject.filter.finishDateLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'projectDefinition',
        label: 'label.sith.prd.sithMesPrdSdProject.entity.projectDefinition',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'startDate',
        label: 'label.sith.prd.sithMesPrdSdProject.entity.startDate',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'finishDate',
        label: 'label.sith.prd.sithMesPrdSdProject.entity.finishDate',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdSdProject.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesPrdSdProject, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
